import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import { API_URL } from '../../api';
import { Save, Check, X, AlertTriangle } from 'lucide-react';
import {PatternFormat} from "react-number-format";

function EditarComunicado() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [menuAberto, setMenuAberto] = useState(false);
  const [comunicado, setComunicado] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [erro, setErro] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    async function fetchComunicado() {
      setCarregando(true);
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/comunicados/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erro ao buscar comunicado: ${response.status}`);
        }
        
        const data = await response.json();
        // AQUI O CONSOLE LOG ESTÁ SENDO EXIBIDO 2 VEZES
        console.log('data', data)
        setComunicado(data);
        setCarregando(false);
      } catch (error) {
        console.error('Erro ao buscar dados do comunicado:', error);
        setErro('Não foi possível carregar os dados do comunicado.');
        setCarregando(false);
        
        // Fallback para desenvolvimento caso a API não esteja disponível
        
      }
    }
    fetchComunicado();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setComunicado(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      // Em produção, substituir por chamada real à API
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('titulo', comunicado.titulo);
      formData.append('descricao', comunicado.descricao);
      if (selectedFile) {
        formData.append('documento', selectedFile);
      }
      await fetch(`${API_URL}/comunicados/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData
      });

      // Simulação para desenvolvimento
      // await new Promise(resolve => setTimeout(resolve, 800));
      alert('Comunicado atualizado com sucesso!');
      setSalvando(false);
    } catch (error) {
      console.error('Erro ao salvar comunicado:', error);
      setErro('Não foi possível salvar as alterações.');
      setSalvando(false);
    }
  };

  if (carregando) {
    return (
      <div className="dashboard-root">
        <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
        <div className="main-content">
          <Topbar
            setMenuAberto={setMenuAberto}
            titulo="Editar Comunicado"
          />
          <div className="conteudo-dashboard">
            <div className="carregando">Carregando dados do comunicado...</div>
          </div>
        </div>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="dashboard-root">
        <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
        <div className="main-content">
          <Topbar
            setMenuAberto={setMenuAberto}
            titulo="Editar Comunicado"
          />
          <div className="conteudo-dashboard">
            <div className="erro-container">
              <AlertTriangle size={48} color="#e11d48" />
              <h2>Erro ao carregar dados</h2>
              <p>{erro}</p>
              <button 
                className="btn-voltar" 
                onClick={() => navigate('/comunicados')}
              >
                Voltar para a lista
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar
          setMenuAberto={setMenuAberto}
          titulo="Editar Comunicado"
          
        />
        <div className="conteudo-dashboard">
          <div className="card-page-main p-relative">
            <div className="card-page-main-header">
              <div className="card-page-main-header-title">
                <h2>Editar Comunicado</h2>
              </div>
              
            </div>

            <form onSubmit={handleSubmit} className="comunicado-edit-form">
              <div className="">
                <div className="form-group">
                  <label htmlFor="titulo">Título</label>
                  <input
                    type="text"
                    id="titulo"
                    name="titulo"
                    value={comunicado.titulo}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="descricao">Descrição</label>
                  <textarea
                    id="descricao"
                    name="descricao"
                    value={comunicado.descricao}
                    onChange={handleChange}
                    rows={5}
                    required
                  />
                </div>
                
                <div className="form-group mt-2">
                  <label htmlFor="documento">Documento</label>
                  {comunicado.documento_anexado && (
                    <p className="text-sm text-gray-500 mt-1">
                      Documento atual: <a href={comunicado.documento_anexado} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Visualizar Documento</a>
                    </p>
                  )}
                  <input
                    type="file"
                    id="documento"
                    name="documento"
                    onChange={handleFileChange}
                    className="input-field"
                  />
                </div>
              </div>
              
              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-cinza-claro"
                  onClick={() => navigate('/comunicados')}
                  disabled={salvando}
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={salvando}
                >
                  {salvando ? 'Salvando...' : (
                    <>
                      <Save size={18} style={{ marginRight: 6 }} /> Salvar Alterações
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditarComunicado;
